import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type {
	LWApiPublicAccountUserStateDataListForKeyParamsRawI,
	LWApiPublicAccountUserStateDataListForKeyResultRawI,
} from '@liquidweb-dev/club-sauce/public/account/user/stateData/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const ACCOUNT_USER_STATEDATA_LISTFORKEY_QUERY_KEY =
	'/account/user/statedata/listforkey';

export const useAccountUserStatedataListforkey = (
	params: LWApiPublicAccountUserStateDataListForKeyParamsRawI,
	options?: UseQueryOptions<
		LWApiPublicAccountUserStateDataListForKeyResultRawI,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [ACCOUNT_USER_STATEDATA_LISTFORKEY_QUERY_KEY, params],
		queryFn: () => api.account.user.stateData.apiRaw.listForKey(params),
		...options,
	});

export default useAccountUserStatedataListforkey;
